import styled from 'styled-components';
import QuIcon from '@quiqupltd/qu-react-sdk/lib/components/qu-icon';
import { media } from '@quiqupltd/qu-react-sdk/lib/styles/mixins/media';
import { pxToRem } from '@quiqupltd/qu-react-sdk/lib/utils/styles';

export const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: ${pxToRem(12)};
  padding: 32px 48px;
  background: ${props => props.theme.offWhite};

  ${media.down('phone')`
    padding: 16px 15px;
  `};
`;
export const Wrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: baseline;
`;

export const Text = styled.span`
  color: ${props => props.theme.sky500};
`;

export const Label = styled.span`
  text-transform: uppercase;
`;

export const Icon = styled(QuIcon)`
  margin-left: 5px;
  top: 3px;
  position: relative;
`;

export const TextOrderId = styled.p`
  color: ${props => props.theme.sky500};
  ${props => (props.isCustomized ? 'margin: 0' : 'margin: 0 0 10px 0')};
`;

export const LogoLink = styled.a`
  color: ${props => props.theme.sky500};
`;



// WEBPACK FOOTER //
// ./src/app/footer/styles.js